import { usePath } from 'common/hooks';

export const useActivePath = (): string => {
  return usePath(`/active`);
};
